import { useEffect, useMemo } from 'react';
import Icons from '../../../../components/Common/Icons/Icons';
import { MenuItem, useMenuProvider } from '../../../../context/menuHeader';
import Dashboard from '../../../pages/dashboard';
import UserManagement from '../../../pages/user-management';
import MessageManager from '../../../pages/message-manager';
import JobStatus from '../../../pages/job-status';
import JobDetails from '../../../pages/job-status/details';
import MessageManagerBuilder from '../../../pages/message-manager/builder';
import OldStyleMenu from './OldStyleMenu';
import { getSettingItemFromStorage } from '../../../../components/Pages/Home/SettingsModal/storage-utils';
import Inventory from '../../../pages/inventory';
import AccountManagement from '../../../pages/account-management';
import ENotification from '../../../pages/e-notification';
import ENotificationCreateNewTemplate from '../../../pages/e-notification/create-new-template';
import ENotificationActiveTemplate from '../../../pages/e-notification/active-template';
import ENotificationFilledTemplate from '../../../pages/e-notification/filled-template';
import ENotificationOtherTemplate from '../../../pages/e-notification/other-template';
import ENotificationArchiveTemplate from '../../../pages/e-notification/archive-template';
import ENotificationFilledArchiveTemplate from '../../../pages/e-notification/archive-template/filled-archive-template';
import ENotificationFilledArchiveMonthlyTemplate from '../../../pages/e-notification/archive-template/filled-archive-monthly-template';
import ReturnMail from '../../../pages/return-mail';
import AccountManagementCreateAccount from '../../../pages/account-management/create-account';
import AccountManagementCreateUser from '../../../pages/account-management/create-user';
import AccountManagementAccountDetail from '../../../pages/account-management/account-detail';
import { MenuRoute } from '../../../../components/Layout/Menu';
import UserManagementRoles from '../../../pages/user-management/roles';
import UserManagementSingleUser from '../../../pages/user-management/single-user';
import UserManagementCreateUser from '../../../pages/user-management/create-user';
import UserManagementCreateRole from '../../../pages/user-management/create-role';
import UserManagementEditRole from '../../../pages/user-management/edit-role';
import UserManagementTrustedBrowsers from '../../../pages/user-management/trusted-browsers';
import UserManagementManageAlerts from '../../../pages/user-management/manage-alerts';
import UserManagementManageSettingsSaved from '../../../pages/user-management/manage-settings-saved';
import UserManagementApplications from '../../../pages/user-management/applications';
import UserManagementEditApp from '../../../pages/user-management/edit-app';
import InsertManagement from '../../../pages/insert-management';
import InsertManagementCreate from '../../../pages/insert-management/create';
import InsertManagementEditStep1 from '../../../pages/insert-management/edit/step1';
import InsertManagementEditStep2 from '../../../pages/insert-management/edit/step2';
import InsertManagementEditStep3 from '../../../pages/insert-management/edit/step3';
import InsertManagementEditStep4 from '../../../pages/insert-management/edit/step4';
import InsertManagementEditStep5 from '../../../pages/insert-management/edit/step5';
import InsertManagementEditApproval from '../../../pages/insert-management/edit/approval';
import InsertManagementApprove from '../../../pages/insert-management/approve';
import InsertManagementRemove from '../../../pages/insert-management/remove';
import InsertManagementRemoveSuccess from '../../../pages/insert-management/remove-success';
import InsertManagementLink from '../../../pages/insert-management/link';
import InsertManagementModify from '../../../pages/insert-management/modify';
import AdministrativeReports from '../../../pages/administrative-reports';
import PaperlessEnrollment from '../../../pages/administrative-reports/paperless-enrollment';
import LoginSummary from '../../../pages/administrative-reports/login-summary';
import Notification from '../../../pages/administrative-reports/notification';
import EmailCollection from '../../../pages/administrative-reports/email-collection';
import InsertClicks from '../../../pages/administrative-reports/insert-clicks';
import ClickTracking from '../../../pages/administrative-reports/click-tracking';
import LoginActivity from '../../../pages/administrative-reports/login-activity';
import AuditReport from '../../../pages/administrative-reports/audit-report';
import CustomReport from '../../../pages/administrative-reports/custom-report';
import AccountReport from '../../../pages/administrative-reports/account-report';
import UserEnrollment from '../../../pages/administrative-reports/user-enrollment';
import CertifiedMail from '../../../pages/certifiedMail';
import ReverseMailTracking from '../../../pages/reverseMailTracking';
import ReverseMailSearchResult from '../../../pages/reverseMailTracking/search-result';
import ReverseMailDetails from '../../../pages/reverseMailTracking/details';
import InsertManagementDetail from '../../Pages/InsertManagement/Detail';
import EInsertManagement from '../../../pages/e-insert-management';
import EInsertManagementUpload from '../../../pages/e-insert-management/upload';
import EInsertManagementEdit from '../../../pages/e-insert-management/edit';
import TransferStaments from '../../../pages/transfer-staments';
import AccountsList from '../../../pages/transfer-staments/list';
import AccountStatements from '../../../pages/transfer-staments/statements';
import AccountStatementsPopUp from '../../../pages/transfer-staments/statements-pop-up';
import DestinationAccount from '../../../pages/transfer-staments/destination-account';
import PopUpAlert from '../../../pages/pop-up-alert';
import BannerManagement from '../../../pages/banner-management';
import BannersList from '../../../pages/banner-management/list';
import BannerEdit from '../../../pages/banner-management/edit';

export const routes: MenuRoute[] = [
  {
    name: 'Dashboard',
    icon: <Icons.Dashboard />,
    order: 20,
    route: {
      path: 'infoTrac', // dashboard
      element: <Dashboard />, // <InfoTrac />
    },
    children: [
      {
        name: 'User Management',
        icon: <Icons.UserManagement />,
        order: 19,
        route: {
          path: 'user-management',
          element: <UserManagement />,
        },
        children: [
          {
            hidden: true,
            name: 'Roles',
            route: {
              path: 'roles',
              element: <UserManagementRoles />,
            },
          },
          {
            hidden: true,
            name: 'SingleUser',
            route: {
              path: 'single-user',
              element: <UserManagementSingleUser />,
            },
          },
          {
            hidden: true,
            name: 'CreateUser',
            route: {
              path: 'create-user',
              element: <UserManagementCreateUser />,
            },
          },
          {
            hidden: true,
            name: 'EditRole',
            route: {
              path: 'edit-role',
              element: <UserManagementEditRole />,
            },
          },
          {
            hidden: true,
            name: 'TrustedBrowsers',
            route: {
              path: 'trusted-browsers',
              element: <UserManagementTrustedBrowsers />,
            },
          },
          {
            hidden: true,
            name: 'ManageAlerts',
            route: {
              path: 'manage-alerts',
              element: <UserManagementManageAlerts />,
            },
          },
          {
            hidden: true,
            name: 'ManageSettingsSaved',
            route: {
              path: 'manage-settings-saved',
              element: <UserManagementManageSettingsSaved />,
            },
          },
          {
            hidden: true,
            name: 'CreateRole',
            route: {
              path: 'create-role',
              element: <UserManagementCreateRole />,
            },
          },
          {
            hidden: true,
            name: 'Applications',
            route: {
              path: 'apps',
              element: <UserManagementApplications />,
            },
          },
          {
            hidden: true,
            name: 'EditApp',
            route: {
              path: 'edit-app',
              element: <UserManagementEditApp />,
            },
          },
        ],
      },
      {
        name: 'Insert Management',
        icon: <Icons.InsertManagement />,
        order: 18,
        route: {
          path: 'insert-management',
          element: <InsertManagement />,
        },
        children: [
          {
            hidden: true,
            name: 'Create New',
            route: {
              path: 'create',
              element: <InsertManagementCreate />,
            },
          },
          {
            hidden: true,
            name: 'Edit Step 1',
            route: {
              path: 'step1',
              element: <InsertManagementEditStep1 />,
            },
          },
          {
            hidden: true,
            name: 'Edit Step 2',
            route: {
              path: 'step2',
              element: <InsertManagementEditStep2 />,
            },
          },
          {
            hidden: true,
            name: 'Edit Step 3',
            route: {
              path: 'step3',
              element: <InsertManagementEditStep3 />,
            },
          },
          {
            hidden: true,
            name: 'Edit Step 4',
            route: {
              path: 'step4',
              element: <InsertManagementEditStep4 />,
            },
          },
          {
            hidden: true,
            name: 'Edit Step 5',
            route: {
              path: 'step5',
              element: <InsertManagementEditStep5 />,
            },
          },
          {
            hidden: true,
            name: 'Edit Approval',
            route: {
              path: 'approval',
              element: <InsertManagementEditApproval />,
            },
          },
          {
            hidden: true,
            name: 'Detail',
            route: {
              path: 'detail',
              element: <InsertManagementDetail />,
            },
          },
          {
            hidden: true,
            name: 'Approve',
            route: {
              path: 'approve',
              element: <InsertManagementApprove />,
            },
          },
          {
            hidden: true,
            name: 'Remove',
            route: {
              path: 'remove',
              element: <InsertManagementRemove />,
            },
          },
          {
            hidden: true,
            name: 'RemoveSuccess',
            route: {
              path: 'remove-success',
              element: <InsertManagementRemoveSuccess />,
            },
          },
          {
            hidden: true,
            name: 'Link',
            route: {
              path: 'link',
              element: <InsertManagementLink />,
            },
          },
          {
            hidden: true,
            name: 'Modify',
            route: {
              path: 'modify',
              element: <InsertManagementModify />,
            },
          },
        ],
      },
      {
        name: 'Inventory',
        icon: <Icons.Inventory />,
        order: 17,
        route: {
          path: 'inventory',
          element: <Inventory />,
        },
      },
      {
        name: 'Certified Mail',
        route: {
          path: 'certified-mail',
          element: <CertifiedMail />,
        },
      },
      {
        name: 'Reverse Mail Tracking',
        route: {
          path: 'reverse-mail-tracking',
          element: <ReverseMailTracking />,
        },
        children: [
          {
            hidden: true,
            name: 'Search Result',
            route: {
              path: 'search-result',
              element: <ReverseMailSearchResult />,
            },
          },
          {
            hidden: true,
            name: 'Details',
            route: {
              path: 'details',
              element: <ReverseMailDetails />,
            },
          },
        ],
      },
      {
        name: 'Job Status',
        icon: <Icons.JobStatus />,
        route: {
          path: 'job-status',
          element: <JobStatus />,
        },
        children: [
          {
            hidden: true,
            name: 'Job Details',
            route: {
              path: ':id',
              element: <JobDetails />,
            },
          },
        ],
      },
      {
        name: 'Administrative Reports',
        icon: <Icons.AdministrativeReports />,
        route: {
          path: 'administrative-reports',
          element: <AdministrativeReports />,
        },
        children: [
          {
            hidden: true,
            name: 'paperless-enrollment',
            route: {
              path: 'paperless',
              element: <PaperlessEnrollment />,
            },
          },
          {
            hidden: true,
            name: 'login-summary',
            route: {
              path: 'login',
              element: <LoginSummary />,
            },
          },
          {
            hidden: true,
            name: 'notification',
            route: {
              path: 'notification-sent',
              element: <Notification />,
            },
          },
          {
            hidden: true,
            name: 'email-collection',
            route: {
              path: 'email-collection',
              element: <EmailCollection />,
            },
          },
          {
            hidden: true,
            name: 'insert-click-tracking',
            route: {
              path: 'insert-click-tracking',
              element: <InsertClicks />,
            },
          },
          {
            hidden: true,
            name: 'click-tracking-report',
            route: {
              path: 'click-tracking-report',
              element: <ClickTracking />,
            },
          },
          {
            hidden: true,
            name: 'admin-login-activity',
            route: {
              path: 'admin-login-activity',
              element: <LoginActivity />,
            },
          },
          {
            hidden: true,
            name: 'audit-log',
            route: {
              path: 'audit-log',
              element: <AuditReport />,
            },
          },
          {
            hidden: true,
            name: 'custom-report',
            route: {
              path: 'custom-reports',
              element: <CustomReport />,
            },
          },
          {
            hidden: true,
            name: 'account-report',
            route: {
              path: 'account-creation-report',
              element: <AccountReport />,
            },
          },
          {
            hidden: true,
            name: 'user-enrollment',
            route: {
              path: 'user-enrollment-report',
              element: <UserEnrollment />,
            },
          },
        ],
      },
      {
        name: 'Message Manager',
        icon: <Icons.MessageFilled />,
        route: {
          path: 'message-manager',
          element: <MessageManager />,
        },
        children: [
          {
            hidden: true,
            name: 'Builder',
            route: {
              path: 'builder',
              element: <MessageManagerBuilder />,
            },
            children: [
              {
                hidden: true,
                name: 'Builder',
                route: {
                  path: ':id',
                  element: <MessageManagerBuilder />,
                },
              },
            ],
          },
        ],
      },
      {
        name: 'Account Management',
        icon: <Icons.AccountManagement />,
        route: {
          path: 'account-management',
          element: <AccountManagement />,
        },
        children: [
          {
            hidden: true,
            name: 'Create Account',
            route: {
              path: 'create-account',
              element: <AccountManagementCreateAccount />,
            },
          },
          {
            hidden: true,
            name: 'Create User',
            route: {
              path: 'create-user',
              element: <AccountManagementCreateUser />,
            },
          },
          {
            hidden: true,
            name: 'Account Detail',
            route: {
              path: ':id',
              element: <AccountManagementAccountDetail />,
            },
          },
        ],
      },
      // {
      //   name: 'Account Management',
      //   icon: <Icons.AccountManagement />,
      //   route: {
      //     path: 'account-management',
      //     element: <AccountManagement />,
      //   },
      //   children: [
      //     {
      //       hidden: true,
      //       name: 'Create New User',
      //       route: {
      //         path: 'create-new-user',
      //         element: <AccountManagementCreateNewUser />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Confirmation Request',
      //       route: {
      //         path: 'create-new-user/confirmation-request',
      //         element: <CreateUserConfirmationRequest />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'User Info',
      //       route: {
      //         path: 'user-information',
      //         element: <AccountManagementUserInformation />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Create New Account',
      //       route: {
      //         path: 'create-new-account',
      //         element: <AccountManagementCreateNewAccount />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Confirmation Request',
      //       route: {
      //         path: 'create-new-account/confirmation-request',
      //         element: <CreateAccountConfirmationRequest />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Account Info',
      //       route: {
      //         path: 'account-information',
      //         element: <AccountManagementAccountInformation />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'List of accounts',
      //       route: {
      //         path: 'list-of-accounts',
      //         element: <AccountManagementListOfAccounts />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Statement',
      //       route: {
      //         path: 'statement-pie-chart',
      //         element: <AccountManagementStatement />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Bill',
      //       route: {
      //         path: 'bill',
      //         element: <AccountManagementBill />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Accounts',
      //       route: {
      //         path: 'list-of-accounts/account',
      //         element: <AccountManagementSingleAccount />,
      //       },
      //     },
      //     {
      //       hidden: true,
      //       name: 'Batch Download',
      //       route: {
      //         path: 'batch-download',
      //         element: <AccountManagementBatchDownload />,
      //       },
      //     },
      //   ],
      // },
      {
        name: 'E-Insert Management',
        icon: <Icons.EInsertManagement />,
        route: {
          path: 'e-insert-management',
          element: <EInsertManagement />,
        },
        children: [
          {
            hidden: true,
            name: 'Upload',
            route: {
              path: 'upload',
              element: <EInsertManagementUpload />,
            },
          },
          {
            hidden: true,
            name: 'Edit',
            route: {
              path: 'edit',
              element: <EInsertManagementEdit />,
            },
          },
        ],
      },
      {
        name: 'Transfer Statements',
        icon: <Icons.ClipboardFilled />,
        route: {
          path: 'transfer-statements',
          element: <TransferStaments />,
        },
        children: [
          {
            hidden: true,
            name: 'Accounts List',
            route: {
              path: 'accounts-list',
              element: <AccountsList />,
            },
          },
          {
            hidden: true,
            name: 'Accounts Statements',
            route: {
              path: 'account-statements',
              element: <AccountStatements />,
            },
          },
          {
            hidden: true,
            name: 'Accounts Statements Pop Up',
            route: {
              path: 'account-statements-pop-up',
              element: <AccountStatementsPopUp />,
            },
          },
          {
            hidden: true,
            name: 'Destination Account',
            route: {
              path: 'destination-account',
              element: <DestinationAccount />,
            },
          },
        ],
      },
      {
        name: 'Return Mail',
        icon: <Icons.ClipboardFilled />,
        route: {
          path: 'return-mail',
          element: <ReturnMail />,
        },
      },
      {
        name: 'PopUp Alert',
        icon: <Icons.ClipboardFilled />,
        route: {
          path: 'pop-up-alert',
          element: <PopUpAlert />,
        },
      },
      {
        name: 'Banner Management',
        icon: <Icons.ClipboardFilled />,
        route: {
          path: 'banner-management',
          element: <BannerManagement />,
        },
        children: [
          {
            hidden: true,
            name: 'Banners List',
            route: {
              path: 'list',
              element: <BannersList />,
            },
          },
          {
            hidden: true,
            name: 'Banner Edit',
            route: {
              path: 'edit',
              element: <BannerEdit />,
            },
          },
        ],
      },
      {
        name: 'E-Notification',
        icon: <Icons.BellFilled />,
        route: {
          path: 'e-notification',
          element: <ENotification />,
        },
        children: [
          {
            hidden: true,
            name: 'Create New Template',
            route: {
              path: 'create-new-template',
              element: <ENotificationCreateNewTemplate />,
            },
          },
          {
            hidden: true,
            name: 'Filled Template',
            route: {
              path: 'filled-template',
              element: <ENotificationFilledTemplate />,
            },
          },
          {
            hidden: true,
            name: 'Active Template',
            route: {
              path: 'active-template',
              element: <ENotificationActiveTemplate />,
            },
          },
          {
            hidden: true,
            name: 'Other Template',
            route: {
              path: 'other-template',
              element: <ENotificationOtherTemplate />,
            },
          },
          {
            hidden: true,
            name: 'Archive Template',
            route: {
              path: 'archive-template',
              element: <ENotificationArchiveTemplate />,
            },
          },
          {
            hidden: true,
            name: 'Filled Archive Template',
            route: {
              path: 'archive-template/filled-template',
              element: <ENotificationFilledArchiveTemplate />,
            },
          },
          {
            hidden: true,
            name: 'Filled Monthly Archive Template',
            route: {
              path: 'archive-template/filled-monthly-template',
              element: <ENotificationFilledArchiveMonthlyTemplate />,
            },
          },
        ],
      },
    ],
  },
];

export function generateMenuItems(propRoutes: MenuRoute[], parentPath = '', activePath = ''): MenuItem[] {
  return propRoutes.reduce<MenuItem[]>((menuItems, route) => {
    const path = `${parentPath}/${route.route?.path ?? ''}`.replace(/\/+/g, '/'); // Remove redundant slashes

    const isSettingsVisible = getSettingItemFromStorage(path);

    const menuItem: MenuItem = {
      path,
      label: route.name ?? '',
      icon: route.icon,
      hidden: route.hidden,
      // If item exist in settings session storage then take this value, in other case show as visible
      settingsVisible: isSettingsVisible !== undefined ? isSettingsVisible : true,
      order: route.order,
      children: [],
      visibleOnlyWithAccount: !!route.visibleOnlyWithAccount,
    };

    if (!route.hidden) {
      menuItems.push(menuItem);
    }

    if (route.children) {
      const childrenMenuItems = generateMenuItems(route.children, '', activePath);

      if (route.childrenAsMenu) {
        menuItem.children = childrenMenuItems;
      } else {
        menuItems.push(...childrenMenuItems);
      }
    }

    return menuItems.sort((a, b) => (b.order ?? 0) - (a.order ?? 0));
  }, []);
}

export const alwaysActiveItems = [
  '/infoTrac',
  '/infoTrac/user-management',
  '/infoTrac/insert-management',
  '/infoTrac/inventory',
];

interface IInfoTracMenu {
  isOldPage?: boolean;
}

export default function InfoTracMenu({ isOldPage }: IInfoTracMenu) {
  const { handleMenuItems } = useMenuProvider();

  const preparedMenuItems = useMemo(
    () => generateMenuItems(routes).filter(item => item.settingsVisible), // Show only items which active in settings.
    [routes],
  );

  useEffect(() => {
    handleMenuItems(preparedMenuItems);
  }, []);

  return (
    /** TODO when change header from old one to new one - change 'top-[number]' in component 'PageSubHeader'
     * to same number as current header have. */
    // <HeaderMenu
    //   mainMenu={<MainNav />}
    //   rightMenu={<RightNav />}
    // />
    <OldStyleMenu mainMenuItems={preparedMenuItems} isOldPage={isOldPage} />
  );
}

InfoTracMenu.defaultProps = {
  isOldPage: false,
};
